import { NewButton, NewButtonVariant } from "@visiblethread/react-components";
import { LogIn } from "lucide-react";
import { string } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { selectFiles } from "slices/workspace/selectors";

import { redirectToSharepointAuth } from "../../../../slices/sharepoint/actions";

const SharepointAuthPrompt = ({ target }) => {
  const dispatch = useDispatch();
  const files = useSelector(selectFiles);
  const hasLocalFiles = files.length > 0;

  const handleSignIn = () => {
    dispatch(redirectToSharepointAuth(target));
  };

  return (
    <div className="sharepoint_panel__auth_prompt">
      <LogIn size={48} strokeWidth={1.5} />
      <h3>Connect To SharePoint</h3>
      <p>Sign in with your Microsoft account to browse and select files.</p>
      {hasLocalFiles && (
        <p className="sharepoint_panel__auth_prompt__warning">
          You have local files selected. They will need to be re-selected after
          signing in.
        </p>
      )}
      <NewButton variant={NewButtonVariant.l1} onClick={handleSignIn}>
        Sign In
      </NewButton>
    </div>
  );
};

SharepointAuthPrompt.propTypes = {
  target: string.isRequired,
};

export default SharepointAuthPrompt;
